function SvgComponent({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      stroke="currentColor"
    >
      <path
        d="M17 5.75882L17 16C17 20 14.6004 21 12.5 21C10.3996 21 8 20 8 16L8 5.99999C8 5 8.5 3 11 3C13.5 3 14 4.99999 14 5.99999V16.3353C14 17.1929 13.5 18 12.5 18C11.5 18 11 17.1929 11 16.3353L11 6"
        stroke="inherit"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgComponent;
